import StateStoreBase from "./StateStoreBase.js";
class UserStore extends StateStoreBase {
  constructor() {
    super(...arguments);
    this.userInfo = {
      accessToken: "",
      uniqueUserId: null
    };
  }
  get() {
    return this.userInfo;
  }
  isSignedIn() {
    return this.userInfo.accessToken.length > 0;
  }
  populate(info) {
    this.userInfo = {
      ...this.userInfo,
      ...info
    };
    this.notifySubscribers();
  }
}
const userStore = new UserStore();
export {
  UserStore,
  userStore as default
};
//# sourceMappingURL=userStore.js.map
